<template>
  <div id="deCreate">
    <div style="overflow:hidden;" class="left">
      <div class="select-basic" @click="handleSelectProduct">
        <div class="select-basic__left">
          <div
            v-if="isSelect"
            class="el-image select-basic__img"
            style="height: 32px; width: 32px;"
          >
            <img
              :src="currentProduct.skuList ? `${currentProduct.skuList[0].mainPic.picUrl}?x-oss-process=image/resize,m_fill,h_50,w_50` : ''"
              class="el-image__inner"
            />
          </div>
          <span
            v-if="isSelect"
            :title="currentProduct.proName"
            class="select-basic__name text-overflow"
          >
            {{ currentProduct.proName }}
          </span>
          <span v-if="!isSelect" class="select-basic__name text-overflow">
            请选择产品
          </span>
        </div>
        <div class="select-basic__icon flex-center">
          <i style="margin-left: 4px;" class="el-icon-refresh"></i>
        </div>
      </div>
      <el-select v-if="isSelect"  @change="handleSelectSku" v-model="form.skuId" class="left" placeholder="请选择颜色和尺码">
        <el-option
          v-for="item in currentProduct.skuList"
          :key="item.proSkuId"
          :label="item.properVal"
          :value="item.proSkuId"
        >
        </el-option>
      </el-select>
      <div v-if="isSelect && currentSelectProduct" class="basic-price left">￥{{ currentSelectProduct.price }}</div>
      <div v-if="isSelect && currentSelectProduct" class="product left">
        <span style="color: #4934b2;" @click="handleJumpProduct">产品详情</span>
      </div>
    </div>
    <div class="buttons">
      <el-button @click="handleSaveDesign" type="danger">保存设计</el-button>
    </div>
    <el-dialog :close-on-click-modal="false"  
      class="product-dialog"
      title="选择产品"
      width="1160px"
      :visible.sync="showProduct"
      
    >
      <div>
        <div style="margin: 8px 0;">
          <el-input
            v-model="queryParams.proName"
            size="small"
            type="text"
            autocomplete="off"
            placeholder="请搜索产品名称"
            style="width: 1098px;margin: 0 16px 0 0;"
            @keyup.enter.native="getList"
          >
          <i slot="suffix" @click="getList" style="cursor:pointer;margin: 5px 6px 0 6px;font-size: 19px;" class="el-icon-search"></i>
          </el-input>
        </div>
        <div style="overflow:hidden;">
          <div style="width:252px;" class="left">
            <div class="menu left_url_tab">
            <div style="margin: 0 0 6px 0;font-size: 14px;" class="title">产品分类</div>
            <el-tree
              :data="typeIdTree"
              :props="defaultProps"
              @node-click="handleNodeClick"
            ></el-tree>
          </div>
          </div>
          <div class="left"> 
             <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
          :pageSizes="[12, 24 , 36]"
        />
            <div class="product-list">










          <template v-for="(item, index) in tableData">
            <div class="pro-card">
              <div class="pro-card-content-detail">
                <div
                  @mouseover="handleMouseOver(item)"
                  @mouseout="handleMouseOut(item)"
                  @click="handleConfirmProduct(item)"
                  class="card-img"
                >
                  <!-- item.thumb -->
                  <img
                    :style="{ height: imageHeight + 'px' }"
                    :src="
                      item.mainList.length > 0
                        ? item.mainList[item.currentProduct].picUrl
                        : ''
                    "
                    lazy
                  />
                </div>
                <div
                  :style="{
                    width: imageWidth + 'px',
                    top: imageWidth - 49 + 'px',
                  }"
                  :class="`sku-img-list tp-${index}`"
                >
                  <div class="img-content">
                    <ul>
                      <li
                        :class="{ 'is-select': item.currentProduct === number }"
                        @mouseover="handleSelectSku(item, number)"
                        v-for="(record, number) in item.mainList"
                        :key="number"
                        :style="{
                          backgroundColor: dictMap['color'][record.skuName],
                        }"
                      ></li>
                    </ul>
                  </div>
                </div>

                <div class="card-info">
                  <div class="info-div" v-show="item.showTitle">
                    <div class="detail">
                      <div :title="item.proName" class="product-title">
                        {{ item.proName }}
                      </div>
                       <div class="text" style="line-height: 28px">
                        <el-popover
                          placement="bottom-start"
                          width="322"
                          trigger="hover"
                        >
                          <div
                            class="price"
                            slot="reference"
                            style="display:inline-block;position: relative"
                          > 
                            <span class="unit">￥</span
                            >{{
                              item.price
                            }}
                            <i
                              style="margin: 0 0 0 2px;font-size: 12px;"
                              class="el-icon-arrow-down"
                            ></i>
                              <i
                              style="margin: 0 0 0 2px;font-size: 12px;display: none;"
                              class="el-icon-arrow-up"
                            ></i>
                          </div>
                          <div>
                            <div class="prod_drop_con">
                              <div v-for="price,index in item.skuList[0].priceList" :key="index" class="prod_drop_item">
                                <div class="prod_drop_desc">
                                  <span style="color: rgb(51, 51, 51);"
                                    >¥{{price.price}}</span
                                  >
                                  <span>{{price.lowNum}}-{{price.highNum}}件</span>
                                </div>
                                <div v-if="index !== item.skuList[0].priceList.length - 1" class="el-divider el-divider--vertical">
                                  <!---->
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-popover>

                        <span class="date">{{
                          dictMap["prod_days"][item.prodDays]
                        }}</span>
                      </div>
                      <div v-if="false" class="product-tag">
                        <div>
                          {{
                            dictMap["product_type"]
                              ? dictMap["product_type"][item.productType]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="factory text">
                        平均发货时效：{{ item.avgDelivery }}小时
                      </div>
                    </div>
                  </div>
                  <div class="btn-div" v-show="!item.showTitle">
                    <div class="pa c153 price-gradient-box">
                      <div class="relative">
                        <div
                          class="flex-row flex-x-full weight-box"
                          style="margin-bottom:8px;"
                        >
                          <div class="w50">{{ Math.round(Number(item.weight)) }}g</div>
                          <div class="w50">{{ item.pdMaterial }}</div>
                        </div>
                        <div class="pl10 mt15">
                         80%平均时效：{{ item.mostDelivery }}小时
                        </div>
                        <div class="pl10 mt5">
                          平均发货时效：{{ item.avgDelivery }}小时
                        </div>
                        <div class="pl10 mt5 pb10">
                          生产商承诺发货：{{ item.agreeDelivery }}小时
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
          :pageSizes="[12, 24 , 36]"
        />
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import TreeSelect from "@/components/common/treeSelect"
import { getProductList } from "@/api/customProduct/product"
import { getProductTypeTree } from "@/api/product/type"
import { addProduct, getProductDetail } from "@/api/customProduct/product";

export default {
  name: "toolBar",
  inject: ["reload"],
  components: { TreeSelect },
  data() {
    return {
      isSelect: false,
      form: {
        skuId: "",
        skuList: [],
      },
      showProduct: false,
      skuList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 12,
      },
      tableData: [],
      treeSelectProps: {
        value: "typeId", // ID字段名
        label: "typeName", // 显示名称
        children: "childrenTree", // 子级字段名
      },
      productTypeList: [],
      currentProduct: {},
      currentSelectProduct: undefined,
      defaultProps: {
        value: "typeId",
        label: "typeName",
        children: "childrenTree",
      },
      typeIdTree: [],
      queryParams: {
        proName: '',
        pageNum: 1,
        pageSize: 12,
      },
      total: 0,
      imageHeight: "200",
      imageWidth: "223",
    }
  },
  computed: {
    ...mapGetters(["user", "token" , "dictData", "dictMap" ]),
    routeName() {
      return this.$route.path + "?pId=" + this.$route.query.pId
    },
  },
  async mounted() {
    let pId = this.$route.query.pId
    if(!pId){
      pId = '1028'
    }
    if(pId){
      let result = await getProductDetail(pId)
      this.currentProduct = result.data
      this.isSelect = true
      this.form.skuId = this.currentProduct.skuList[0].proSkuId
      this.currentSelectProduct =  this.currentProduct.skuList[0]
    }
  },
  watch: {
    async routeName(){
      let pId = this.$route.query.pId
      if(pId){
        let result = await getProductDetail(pId)
        this.currentProduct = result.data
        this.isSelect = true
        this.form.skuId = ''
      }
    }
  },
  methods: {
    handleSelectProduct() {
      this.showProduct = true
      this.getTree()
      this.getList()
    },
    getTreeNodeId() {},
    async getProductTypeTree() {
      let result = await getProductTypeTree()
      this.productTypeList = result.data
    },
    handleConfirmProduct(record) {
      this.currentProduct = record
      this.currentSelectProduct = undefined
      this.form.skuId = undefined
      this.showProduct = false
      this.isSelect = true
      let pId = record.pId
       this.$router.push({
        path: "/design/online/designer",
        query: { pId: pId },
      })
      // this.reload()
      
    },
    handleJumpProduct() {
      let routeUrl = this.$router.resolve({
        path: "/select/custom/product",
        query: { pId: this.currentProduct.pId },
      })
      window.open(routeUrl.href, "_blank")
    },
    handleSelectSku() {
      for(let record of this.currentProduct.skuList){
        if(record.proSkuId == this.form.skuId){
          this.currentSelectProduct = record
          break
        }
      }
    },
    handleSaveDesign(){
      this.$emit('saveDesign', this.currentProduct.pId)
      //thirdlyDesigner.getDesignInfo
    },
    async getTree() {
      let productType = "01"
      const { data } = await getProductTypeTree({ productType })
      if (data) {
        data.map((record) => {
          record.typeName = `${record.typeName}(${record.proNum})`
          if (record.childrenTree) {
            record.childrenTree.map((item) => {
              item.typeName = `${item.typeName}(${item.proNum})`
              if (item.childrenTree) {
                item.childrenTree.map((menu) => {
                  menu.typeName = `${menu.typeName}(${menu.proNum})`
                })
              }
            })
          }
        })

        this.typeIdTree = data
      }
    },
    getList() {
      this.queryParams.productType = "01"
      getProductList(this.queryParams).then((res) => {
        for (let record of res.rows) {
          record.showTitle = true
          record.currentProduct = 0
        }
        this.tableData = res.rows
        this.total = res.total
        this.loading = false
        this.$nextTick(() => {
          let cardImg = document.querySelector("#deCreate .card-img")
          if (cardImg) {
            let height = cardImg.offsetWidth
            this.imageWidth = cardImg.offsetWidth
            this.imageHeight = height
          }
        })
      })
    },
    handleNodeClick(data) {
      this.queryParams.typeId = data.typeId
      this.getList()
    },
    handleMouseOver(item) {
      item.showTitle = false
    },
    handleMouseOut(item) {
      item.showTitle = true
    },
     handleCheckSku(item, number) {
      item.currentProduct = number
    },
  },
}
</script>

<style scoped lang="scss">
.buttons {
  float: right;
  // margin: 0 16px 0 0;
}
#deCreate {
  background: #ffffff;
  padding: 8px 32px;
  overflow: hidden;
}
.left {
  float: left;
}
.select-basic {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 220px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 0 12px;
  margin-right: 19px;
  float: left;
  line-height: 40px;
  cursor: pointer;
}
.select-basic__left {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.select-basic__name {
  max-width: 122px;
  font-size: 14px;
  color: #000000;
  line-height: 24px;
}
.text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.select-basic__icon {
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #4934b2;
  color: white;
  line-height: 24px;
}
.basic-price {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
  line-height: 40px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-right: 20px;
  color: #f56c6c;
  margin-left: 25px;
}

.product {
  font-size: 14px;
  line-height: 40px;
  margin: 0 0 0 16px;
  cursor: pointer;
}
.select-product {
  cursor: pointer;
  width: 90px;
  height: 90px;
  background: #f7f7f7;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  font-size: 14px;
  color: grey;
  line-height: 24px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 20px;
}
.select-product i {
  font-size: 18px;
}

.search-result-wrap {
  margin-top: 32px;
  background: #ffffff;
}

.search-result-wrap .search-result__title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  background: #ffffd7;
  border: 1px solid #e6e6e6;
  padding: 6px 12px;
  font-size: 14px;
  color: #333;
  line-height: 30px;
}

.search-result-wrap .search-result__title span {
  font-size: 16px;
  font-weight: 700;
  color: #ea0000;
  margin-right: 35px;
}

.search-result-wrap .search-result__content {
}

.search-result-wrap .search-result__content .product-detail-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  text-align: left;
}

.search-result-wrap .search-result__content .product-detail {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  line-height: 30px;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.search-result-wrap .search-result__content .shipping-fee {
  color: #3796f6;
}
.search-result-wrap thead th {
  height: 40px;
  background: #f2f2f2;
  font-size: 16px;
  color: #000;
  line-height: 40px;
  text-align: center;
  border: 1px solid #e6e6e6;
  font-weight: normal;
}

.search-result-wrap tbody td {
  text-align: center;
  border: 1px solid #e6e6e6;
  padding: 20px;
  width: 163px;
  font-size: 14px;
  color: #333;
  line-height: 24px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
.select-product-title {
  width: 100%;
  height: 40px;
  background: #f2f2f2;
  font-size: 14px;
  font-weight: 700;
  color: #333;
  line-height: 40px;
  margin: 24px 0 28px 0;
  padding-left: 20px;
}
.select-product-content {
  width: 100%;
  .select-product-item {
    margin-bottom: 10px;
    width: 100%;
    clear: both;
    overflow: hidden;
    cursor: pointer;
    .product-img {
      width: 120px;
      height: 120px;
      margin-right: 26px;
    }
    .product-name {
      font-size: 16px;
      font-weight: 700;
      color: #333;
      line-height: 30px;
      margin: 0;
    }
    .product-color,
    .product-size {
      font-size: 14px;
      color: grey;
      line-height: 30px;
    }
  }
  .select-product-item :hover {
    background: lavender;
  }
}
.product-dialog ::v-deep .el-dialog__body {
  height: 60vh;
  overflow-y: auto;
}

.left_url_tab{
  border: inherit;
  margin: 0 1px 0 0;
}
.left_url_tab
  ::v-deep
  .is-current
  > .el-tree-node__content
  > .el-tree-node__label {
  background: #4934b2;
  padding: 0 4px;
  border-radius: 4px;
  color: #ffffff;

}
.left_url_tab ::v-deep .el-tree-node:focus > .el-tree-node__content {
  background-color: inherit;
}
.left_url_tab ::v-deep .el-tree-node__content{
  padding: 1px 0;
}

 .pro-card {
  border: 3px solid transparent;
  padding: 0;
  margin-top: 0px;
}
 .pro-card .pro-content {
  border: 0;
  border-radius: 5px;
  padding: 0px 8px 8px 8px;
  box-sizing: border-box;
}
.product-list{
  width:  860px;
}

  .product-list {
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 0 0 2px;
    ::v-deep .pro-card:first-child {
    }
    ::v-deep .pro-card:last-child {
    }

    .pro-card {
      width: 270px;
      float: left;
      box-sizing: border-box;
      margin: 4px 12px 12px 4px;
      background: #ffffff;
      border-radius: 5px;
      background: transparent;
      position: relative;
      .pro-card-content-detail:hover {
        .sku-img-list {
          display: block;
        }
      }

      .pro-card-content-detail {
          padding: 0;
          border: 1px solid #ddd;
          background: #ffffff;
      }
      .detail {
        line-height: 30px;
      }
      .unit {
        font-size: 12px;
      }
      .card-img {
        cursor: pointer;
      }
      .image {
        padding: 16px;
        cursor: pointer;
      }
      .text {
        overflow: hidden;
        font-size: 14px;
      }
      .product-title {
        font-size: 14px;
        box-sizing: border-box;
        padding-bottom: 4px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .product-tag {
        line-height: 14px;
        margin: 0 0 10px 0;
        div {
          display: inline-block;
          font-size: 12px;
          padding: 2px 6px;
          background: #4934b2;
          border-radius: 5px;
          color: #ffffff;
        }
      }
     .factory {
         border-top: 1px solid #ebeef5;
        margin: 6px 0 0 0;
        padding: 3px 0 0 0;
        line-height: 26px;
      }
      .price {
        float: left;
        font-size: 18px;
        font-weight: bold;
      }
      .date {
        float: right;
      }
    }
    .pro-card:hover {
      cursor: auto;
      color: #000 !important;
      box-shadow: rgb(0 0 0 / 5%) 2px 6px 10px 5px;
    }
  }

.form-body {
  margin-right: 8px;
  padding-bottom: 6px;
  padding: 10px 0;
}
.form {
  padding: 0 16px;
}

.sku-img-list {
  clear: both;
  width: 223px;
}
.sku-img-list .prev {
  float: left;
  margin-right: 2px;
}
.sku-img-list .next {
  float: right;
}
.sku-img-list .prev,
.pro-card .pro-content .sku-img-list .next {
  display: block;
  font-family: "宋体";
  text-align: center;
  width: 10px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-decoration: none;
}
.sku-img-list .img-content {
  position: relative;
  height: 45px;
  overflow: hidden;
}
.sku-img-list ul {
  position: absolute;
  width: 99999px;
  height: 40px;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-left: 0px;
  list-style-type: none;
}
.sku-img-list ul li {
  float: left;
  width: 30px;
  height: 30px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #ebeef5;
  margin-right: 4px;
}
.sku-img-list ul li img {
  width: 29px;
  height: 29px;
}
.sku-img-list ul li img:hover {
}
.price-gradient-box {
  overflow: hidden;
  width: 100%;
  background: #fff;
  z-index: 100;
  transform: translateZ(1000px);
  font-size: 12px;
}
.price-gradient-box .weight-box {
  height: 28px;
  line-height: 28px;
  border: 1px solid #ededed;
  text-align: center;
}
.price-gradient-box .weight-box div:not(:first-child) {
  border-left: 1px solid #ededed;
}
.price-gradient-box > div {
  background: #fff;
}
.price-gradient-box:hover,
.com-pt-img:hover ~ .price-gradient-box {
  bottom: 5px;
  left: 0;
  overflow: hidden;
  z-index: 100;
  transform: translateZ(1000px);
}
.price-gradient-box .swiper-slide {
  text-align: center;
  border: 1px solid #ededed;
  padding: 10px 0;
}
.price-gradient-box .swiper-slide + .swiper-slide {
  border-left: none;
}
.product-swiper-box .next-btn,
.product-swiper-box .per-btn,
.price-gradient-box .next-btn,
.price-gradient-box .per-btn {
  z-index: 2;
  top: 60px;
  padding: 5px;
  width: 20px;
  height: 20px;
  line-height: 0px;
  background: rgba(235, 246, 255, 0.5);
  text-align: center;
}
.w50 {
  width: 50% !important;
}
.flex-x-full {
  -webkit-box-pack: justify;
  -moz-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.flex-row {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
}
.red {
  color: #ff4d3a !important;
}
.c153 {
  color: rgb(153, 153, 153);
}
.filter {
  background: #ffffff;
  border-top: 1px solid rgb(221, 221, 221);
  margin: 4px 0 0 0;
  overflow: hidden;
  padding: 12px 16px 0 16px;
}
.left {
  float: left;
}
.right {
  float: right;
}
.is-select {
  border: 1px solid #333333 !important;
}
 .card-img:hover {
  // .card-info .info-div {
  //   opacity: 0;
  // }
  // .card-info .btn-div {
  //   opacity: 1;
  // }
}
 .pro-card .card-info {
  height: 98px;
}
#custom-online .tab-body .pro-card .card-img img{}
.pro-card .card-img img{
  width: 100%;
}

#custom-online .tab-body .pro-card .card-info {
  position: relative;
}
#custom-online .tab-body .pro-card .card-info .info-div {
  opacity: 1;
}
#custom-online .tab-body .pro-card .card-info .btn-div {
  opacity: 1;
  height: 65px;
  position: absolute;
  top: 19px;
  width: calc( 100% - 30px);
  display: flex;
  justify-content: center;
  align-items: center;
}
#custom-online .tab-body .pro-card .card-info .btn-div .cus-btn {
  height: 40px;
  border: 1px solid #4934b2;
  width: 80%;
  border-radius: 1px;
  background: #4934b2;
  color: white;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

#custom-online .tab-body .pro-card .card-info .info-div .span-price {
  color: rgb(0, 122, 255);
}
#custom-online .tab-body .pro-card .card-info .info-div .el-row {
  font-size: 14px;
}
#custom-online .tab-body .pro-card .card-info .info-div .el-row .el-col {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#custom-online .tab-body .pro-card .card-info .info-div .el-row {
  padding-left: 10px;
}
#custom-online .tab-body .pro-card .pro-content {
  background-color: white;
  border: 3px solid #eaeaea;
  display: grid;
  justify-content: center;
}
#custom-online .tab-body .pro-card .pro-content:hover {
  border: 3px solid white;
  box-shadow: 0px 0px 10px #93e2ff;
}
#custom-online .tab-body .pro-card .pro-content .sku-img-list {
  clear: both;
  width: 223px;
}
#custom-online .tab-body .pro-card .pro-content .sku-img-list .prev {
  float: left;
  margin-right: 2px;
}
#custom-online .tab-body .pro-card .pro-content .sku-img-list .next {
  float: right;
}
#custom-online .tab-body .pro-card .pro-content .sku-img-list .prev,
.tab-body .pro-card .pro-content .sku-img-list .next {
  display: block;
  font-family: "宋体";
  text-align: center;
  width: 10px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-decoration: none;
}
#custom-online .tab-body .pro-card .pro-content .sku-img-list .img-content {
  float: left;
  position: relative;
  width: 200px;
  height: 40px;
  overflow: hidden;
}
#custom-online .tab-body .pro-card .pro-content .sku-img-list ul {
  position: absolute;
  width: 99999px;
  height: 40px;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-left: 0px;
  list-style-type: none;
}
#custom-online .tab-body .pro-card .pro-content .sku-img-list ul li {
  float: left;
  width: 40px;
  text-align: center;
  cursor: pointer;
}
#custom-online .tab-body .pro-card .pro-content .sku-img-list ul li img {
  width: 30px;
  height: 30px;
  border: 1px solid #ccc;
  padding: 2px;
  object-fit: contain;
}
#custom-online .tab-body .pro-card .pro-content .sku-img-list ul li img:hover {
  border: 2px solid red;
  padding: 1px;
}
.prod_drop_con {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: center;
}
.prod_drop_item, .prod_drop_item {
    display: flex;
    flex-direction: row;
    align-items: center;
}
 .prod_drop_desc, .prod_drop_desc {
    display: flex;
    flex-direction: column;
}
.prod_drop_item, .prod_drop_item {
    display: flex;
    flex-direction: row;
    align-items: center;
}
 .prod_drop_desc span:nth-child(1), .prod_drop_desc span:nth-child(1) {
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Semibold, "PingFang SC";
    font-weight: 600;
    color: rgb(153, 153, 153);
    line-height: 20px;
}
.prod_drop_desc span:nth-child(2), .prod_drop_desc span:nth-child(2) {
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, "PingFang SC";
    font-weight: 400;
    color: rgb(153, 153, 153);
    line-height: 20px;
}
.sku-img-list {
  position: absolute;
  display: none;
}
.sku-img-list {
  top: 239px;
  left: 21px;
}

.product-list .pro-card .card-info .btn-div {
  opacity: 1;
  height: 65px;
  position: absolute;
  top: 29px;
  width: calc( 100% - 30px);
  display: flex;
  justify-content: center;
  align-items: center;
}
.pro-card-content-detail:hover {
  .sku-img-list {
    display: block;
  }
}
.pro-card .card-info {
  position: relative;
  padding: 8px 12px;
}

.select-basic__img{
  margin: 0 8px 0 0;
}


.detail .price:hover{
  .el-icon-arrow-down{
    display: none;
  }
  .el-icon-arrow-up{
    display: inline-block !important;
  }
}

</style>
